const NOT_FOUND_IMAGE_SRC = {
  LISTING: '/img/listing-placeholder.png',
};

export default NOT_FOUND_IMAGE_SRC;
